import React, { Component } from "react";

import { Helmet } from "react-helmet";

import ContactMap from "components/ContactMap/Map";
import ContactTabs from "components/ContactCategories/Contact";
import SocialContainer from "components/SocialContainer/SocialContainer";
import TextBlock from "components/TextBlock/TextBlock";
import headerPhoto from "assets/images/Assortiment/01_Headerfoto/FPG101.jpg";
import { I18n } from "react-i18next";
import i18n from "../i18n";

export default class Contact extends Component {
  componentDidMount() {
    document.body.classList.add("contact-page");
  }
  componentWillUnmount() {
    document.body.classList.remove("contact-page");
  }
  render() {
    return [
      <Helmet key="head">
        <meta charSet="utf-8" />
        <title>Contact | Forever Plants | Kom gezellig langs</title>
        <meta
          property="og:image"
          content={`${process.env.REACT_APP_SAFE_URL}${headerPhoto}`}
        />
        <meta
          name="description"
          content="Wat je ook wilt weten, of waar je ook voor komt; de deur staat voor je open. Geïnteresseerd in ons assortiment? Spreek met één van onze verkoopmedewerkers. Op zoek naar een stage? Dan bij je aan het juiste adres bij Thom. Solliciteren? Bel dan Monique. Nog beter dan bellen; kom langs."
        />
        <meta
          property="og:description"
          content="Wat je ook wilt weten, of waar je ook voor komt; de deur staat voor je open. Geïnteresseerd in ons assortiment? Spreek met één van onze verkoopmedewerkers. Op zoek naar een stage? Dan bij je aan het juiste adres bij Thom. Solliciteren? Bel dan Monique. Nog beter dan bellen; kom langs."
        />
      </Helmet>,
      <I18n>
        {(t, { i18n }) => (
          <div className="wrapper" id="pageWrapper" key="content">
            <TextBlock
              extraClasses="mt24 mb32 contact-block"
              title={t("contactTitle")}
              subtitle={t("contactSubtitle")}
            />
            {/* <ContactMap phone="0174 - 622 668" className="mt32 mb20" /> */}
            <div className="mb20"></div>
            <SocialContainer />
            <TextBlock
              extraClasses="mt60 contact__tabs-title"
              title={t("contactTabsTitle")}
              subtitle={t("contactTabsSubtitle")}
            />
            <ContactTabs />
          </div>
        )}
      </I18n>,
    ];
  }
}



// WEBPACK FOOTER //
// ./src/Pages/Contact.jsx